var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 38,
    viewBox: "0 0 95 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_744_4931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M56.4747 20.537L51.6652 25.3465C51.6652 25.3465 51.5274 25.442 51.4355 25.458L34.8472 26.9709C34.8472 26.9709 34.8319 26.9709 34.8166 26.9709L33.4381 27.4487L32.4884 27.8309L30.8495 28.5953C30.727 28.659 30.7729 28.8501 30.9108 28.8342L48.8469 27.1938C49.1992 27.162 49.383 27.6079 49.1379 27.8468L46.0286 30.9523C46.0286 30.9523 45.9061 31.0478 45.8295 31.0478L13.5414 35.698L10.8456 36.0802L0.935544 37.5135C0.50667 37.5772 0.338184 36.9561 0.751741 36.781L16.0074 30.3152L86.0824 0.232051C86.4653 0.0727962 86.7716 0.566485 86.4806 0.869069L69.7698 17.5589L66.7218 20.6007L65.9712 21.3492L62.9385 24.375L61.2383 26.0791L59.4003 27.9105L57.9605 29.3438L56.2909 31.016L54.2997 33.0066L50.6543 36.6376C50.6543 36.6376 50.5318 36.7332 50.4399 36.7332L42.5976 37.7843C42.2453 37.832 42.0462 37.3861 42.2913 37.1313L45.37 34.0577L48.7856 30.6497L52.5842 26.8594L54.2691 25.1713L58.9101 20.537L62.9538 16.5079L65.4198 14.0394C65.5117 13.9439 65.4198 13.7687 65.282 13.8324L49.674 20.6007",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M91.9492 23.9768L59.9368 30.0762C59.8143 30.0922 59.7377 29.9488 59.8296 29.8533L63.1074 26.493C63.1074 26.493 63.2453 26.3975 63.3372 26.3815L91.9186 23.7061C92.0717 23.7061 92.1024 23.929 91.9492 23.9609V23.9768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M94.1855 21.4606L66.2627 24.4227C65.9104 24.4545 65.7113 24.0086 65.9717 23.7698L69.0657 20.7121C69.0657 20.7121 69.2189 20.6006 69.3261 20.6006L94.1549 20.6961C94.6144 20.6961 94.6603 21.4128 94.1855 21.4606Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_744_4931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 37.6,
    fill: "white",
    transform: "translate(0.522461 0.200195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.61023e320247df17b8698d87a9fda9d7.svg";
export { ForwardRef as ReactComponent };